/** Настройки отображения читалки: живут локально, у каждого устройства свои. */

export type Theme = 'dark' | 'light' | 'sepia'

export interface ReaderSettings {
  theme: Theme
  fontSize: number
  lineHeight: number
  width: number
}

const KEY = 'chita.reader'

export const DEFAULT_SETTINGS: ReaderSettings = {
  theme: 'dark',
  fontSize: 19,
  lineHeight: 1.65,
  width: 38,
}

export function loadSettings(): ReaderSettings {
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return DEFAULT_SETTINGS
    return { ...DEFAULT_SETTINGS, ...(JSON.parse(raw) as Partial<ReaderSettings>) }
  } catch {
    return DEFAULT_SETTINGS
  }
}

export function saveSettings(settings: ReaderSettings): void {
  localStorage.setItem(KEY, JSON.stringify(settings))
}

/** Настройки применяются через CSS-переменные — без перерисовки текста. */
export function applySettings(settings: ReaderSettings): void {
  const root = document.documentElement
  root.dataset.theme = settings.theme
  root.style.setProperty('--reader-size', `${settings.fontSize}px`)
  root.style.setProperty('--reader-leading', String(settings.lineHeight))
  root.style.setProperty('--reader-width', `${settings.width}rem`)
}
